
function Events() {
    return (
      <div className="p-8 text-center">
        <h2 className="text-3xl font-bold mb-4">Events</h2>
        <p>Latest events will appear here.</p>
      </div>
    );
  }
  
  export default Events;
  